import { defineComponent as _defineComponent } from 'vue'
import ExpansionPanel from '@/views/components/ExpansionPanel.vue';
import AlertCard from '@/views/components/AlertCard.vue';
import FiltroOrdenacao from '@/views/components/FiltroOrdenacao.vue';
import SeletorOpcoesImpressão from '@/views/components/SeletorOpcoesImpressão.vue';
import CardResultado from './CardResultado.vue';
import IconPaginaSimplificada from '@/views/components/icons/IconPaginaSimplificada.vue';
import IconPaginaDetalhada from '@/views/components/icons/IconPaginaDetalhada.vue';
import { nextTick, ref, watch } from 'vue';
import { mdiFilterVariant } from '@mdi/js';
import { ConsultaObrasStore } from '../../store/ConsultaObrasStore';
import { storeToRefs } from 'pinia';
import {
  contemNaLista,
  isTodosSelecionados,
  selecionarTodos,
  toggleSelecionado,
} from '@/utils/ListUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResultadoConsulta',
  setup(__props) {

const store = ConsultaObrasStore();

const {
  pageSubfiltros,
  obras,
  totalElementos,
  dataOptions,
  pagina,
  totalHits,
  ordenacoes,
  ordenacaoSelecionada,
  obrasSelecionadas,
} = storeToRefs(store);

const resultadoConsulta = ref();

watch(obras, () => {
  if (obras.value) {
    nextTick().then(() => {
      resultadoConsulta.value?.scrollIntoView({ behavior: 'smooth' });
    });
  }
});

const itensImpressao = [
  {
    text: 'Simplificado',
    value: 'S',
    icone: IconPaginaSimplificada,
  },
  {
    text: 'Detalhado',
    value: 'D',
    icone: IconPaginaDetalhada,
  },
];

return { __sfc: true,store, pageSubfiltros, obras, totalElementos, dataOptions, pagina, totalHits, ordenacoes, ordenacaoSelecionada, obrasSelecionadas, resultadoConsulta, itensImpressao, ExpansionPanel, AlertCard, FiltroOrdenacao, SeletorOpcoesImpressão, CardResultado, mdiFilterVariant, contemNaLista, isTodosSelecionados, selecionarTodos, toggleSelecionado }
}

})